<div class="d-flex align-items-center email-cell">
  <span class="font-weight-bold text-muted username">{{ params.data?.username }}</span>
</div>
